import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError, map } from 'rxjs/operators';
import { PlanSummary } from '../models/plansummary';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';


@Injectable()
export class CareerPlanService {

  private baseUrl = "api/Careerplan/";

  constructor(private httpClient: HttpClient) { }

  getPlanStepSummary(): Observable<PlanSummary> {

    return this.httpClient.get<PlanSummary>(this.baseUrl + "PlanStepSummary")
      .pipe(
        map(result => result),
        catchError(this.handleError)
      );

  }

  getCreateCareerPlanUrl(): Observable<string> {

    return this.httpClient.get(this.baseUrl + "CreateCareerPlanUrl", { responseType: 'text' })
      .pipe(
        map(res => res),
        catchError(this.handleError)
      );
  }

  getCareerPlanActivityUrl(): Observable<string> {
    return this.httpClient.get(this.baseUrl + "CareerPlanActivityUrl", { responseType: 'text' })
      .pipe(
        map(res => res),
        catchError(this.handleError)
      );
  }

  getCareerPlanUrl(): Observable<string> {

    return this.httpClient.get(this.baseUrl + "CareerPlanUrl", { responseType: 'text' })
      .pipe(
        map(res => res),
        catchError(this.handleError)
      );

  }

  getSyncCareerPlanUrl(): Observable<string> {

    return this.httpClient.get(this.baseUrl + "SyncCareerPlanUrl", { responseType: 'text' })
      .pipe(
        map(res => res),
        catchError(this.handleError)
      );

  }

  getCareerPlanGoalsUrl(): Observable<string> {

    return this.httpClient.get(this.baseUrl + "CareerPlanGoalsUrl", { responseType: 'text' })
      .pipe(
        map(res => res),
        catchError(this.handleError)
      );

  }

  getSelfEvaluationUrl(): Observable<string> {

    return this.httpClient.get(this.baseUrl + "SelfEvaluationUrl", { responseType: 'text' })
      .pipe(
        map(res => res),
        catchError(this.handleError)
      )

  }

  getActivityDetails(careerPlanId: string, activityId: number): Observable<any> {

    return this.httpClient.get(this.baseUrl + "ActivityDetails?careerPlanId=" + careerPlanId + "&activityId=" + activityId)
      .pipe(
        map(res => res),
        catchError(this.handleError)
      );
  }

  updateCareerPlan(e101Id: number, careerPlanId: string, careerPlanName: string): Observable<any> {

    return this.httpClient.put(this.baseUrl + "UpdateCareerPlan",
      { e101Id: e101Id, careerPlanId: careerPlanId, careerPlanName: careerPlanName });
  }


  private handleError(err: HttpErrorResponse) {
    console.log(err.message);
    return Observable.throw(err.message);
  }

}
